// extracted by mini-css-extract-plugin
export default {"container":"styles_container__2+dRb","editor-resize-wrapper":"styles_editor-resize-wrapper__c3GMJ","previewer-resize-wrapper":"styles_previewer-resize-wrapper__1JFMR"};